import type { MouseEvent } from 'react'
import { isGalaxyPlanLabel } from '@/utils/planCatalogCore'
import { visibleProjectTypeLabel } from '@/utils/slideProjectTypeLabel'
import { DraggableElement } from './DraggableElement'
import { SLIDE_LAYOUT_FALLBACK } from './slidePreviewTheme'

type SlidePreviewProjectTypeProps = {
  planName: string
  planTipo: string
  projectType?: string
  displayProjectType: string
  leftBlockWidth: number
  projectTypeY?: number
  dragging: boolean
  onDragStart: (e: MouseEvent, key: string) => void
}

export function SlidePreviewProjectType({
  planName,
  planTipo,
  displayProjectType,
  leftBlockWidth,
  projectTypeY,
  dragging,
  onDragStart,
}: SlidePreviewProjectTypeProps) {
  const label = visibleProjectTypeLabel(
    planName,
    displayProjectType || (planTipo === 'servico' ? 'Projeto Fechado' : planTipo === 'avulso' ? 'Projeto Avulso' : ''),
  )
  if (isGalaxyPlanLabel(planName) || !label) return null

  return (
    <DraggableElement
      x={leftBlockWidth * 0.06}
      y={projectTypeY || SLIDE_LAYOUT_FALLBACK.projectTypeY}
      width={`${leftBlockWidth * 0.88}%`}
      dragging={dragging}
      onMouseDown={(e) => onDragStart(e, 'projectType')}
      blockNumber={3}
    >
      <span
        style={{
          color: '#ff2f86',
          fontSize: 'clamp(7px, 1.8cqw, 15px)',
          fontWeight: 700,
          fontFamily: 'Arial, sans-serif',
          textTransform: 'uppercase',
        }}
      >
        {label}
      </span>
    </DraggableElement>
  )
}
